<template>
    <div class="value_with_select-container">
        <div class="custom-select">
            <div class="selected_item">
                <span class="value" v-html="getActive"/>
                <span class="icon-bottom_arrow"/>
            </div>
            <div class="items-container">
                <div class="item"
                     v-for="(element,id) in initialData"
                     @click="selectValue(id)">
                    <span v-html="element.value"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "offer_editable_property_value",
        props: ['initialData', 'defaultKey', 'elementKey'],
        data() {
            return {
                value: '',
                isExpanded: false,
                placeholder: 'test'
            }
        },
        methods: {

            selectValue(id) {
                this.$store.commit({
                    type: 'selectElementOfVariableValues',
                    valueId: id,
                    elementKey: this.elementKey
                });
            },

            toggleExpandOfCustomSelect(e) {

                let target = e.target;

                document.querySelectorAll('.custom-select').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        target.parentElement.classList.toggle("expanded");
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        if(target.parentElement && target.parentElement.parentElement) target.parentElement.parentElement.classList.toggle("expanded");
                        return;

                    } else if (target.classList.contains('items-container')) {

                        target.parentElement.classList.remove("expanded");
                        return;

                    } else if (target.classList.contains('item')) {

                        target.parentElement.parentElement.classList.remove("expanded");
                        return;

                    } else {
                        return;
                    }
                }
            },
        },
        computed: {
            getActive() {
                if (this.initialData !== []) {
                    if (this.$store.state.productCard.custom.variables.hasOwnProperty(this.elementKey)) {
                        let active = this.initialData.find(x => x.code === this.$store.state.productCard.custom.variables[this.elementKey]);
                        return active.value;
                    } else {
                        let active = this.initialData.find(x => x.active === true);
                        if (active !== undefined) {
                            return active.value;
                        } else {
                            this.selectValue(parseInt(this.defaultKey));
                        }
                    }
                }
            },
        },

        mounted() {
            if (this.initialData !== []) {
                if (this.$store.state.productCard.custom.variables.hasOwnProperty(this.elementKey)) {

                } else {
                    this.selectValue(parseInt(this.defaultKey));
                }
            }

            document.addEventListener("click", this.toggleExpandOfCustomSelect);
        },

        beforeDestroy() {
            document.removeEventListener("click", this.toggleExpandOfCustomSelect);
        },
    }
</script>